const STATUS = {
  open: 'Offen',
  new: 'Neu',
  confirmed: 'Bestätigt',
  done: 'Abgeschlossen',
  rejected: 'Abgelehnt',
  cancelled: 'Storniert',
  active: 'Active',
  inactive: 'Inactive',
};

export default STATUS;
